import { NgStyle } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { Dropdown } from '@shared/components/dropdown/model/dropdown';
import { IconsDirective } from '@shared/directives';

@Component({
  selector: 'app-dropdown',
  styleUrl: './dropdown.component.scss',
  templateUrl: './dropdown.component.html',
  imports: [IconsDirective, NgStyle],
})
export class DropdownComponent {
  readonly items = input.required<Dropdown[]>();
  readonly isOpen = input(false);
  readonly isBig = input(false);
  readonly isScroll = input(false);
  readonly customStyle = input<{
    [klass: string]: string | number;
  }>({});
  readonly selected = output<Dropdown>();
}
